import { useParams } from "react-router-dom";

/**
 * Landings de compañía: /sancor-cotizador, /allianz-cotizador...
 * React Router 6 no admite un parámetro pegado a texto en el mismo segmento ("/:compania-cotizador"
 * toma "compania-cotizador" como nombre del parámetro), así que esas URLs caen en "/:rubroURL" y la
 * compañía se saca de acá.
 */
export const companiaDeCotizador = (segmento?: string): string | undefined =>
  /^([a-z0-9-]+)-cotizador$/i.exec(segmento ?? "")?.[1]?.toLowerCase();

/** Compañía de la URL: el parámetro de /auto/cotizacion/:compania/... o la landing /{compania}-cotizador. */
export const useCompania = (): string | undefined => {
  const { compania, rubroURL } = useParams();
  return compania ?? companiaDeCotizador(rubroURL);
};
